import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralButtonsButtonExpandArrowSignature {
  Args: {
    isDisabled?: boolean;
    isExpanded: boolean;
  };
}

const GeneralButtonsButtonExpandArrow = <template>
  <button
    class="btn button--unstyled button-expand-arrow
      {{if @isDisabled 'button-expand-arrow--disabled'}}"
    type="button"
  >
    <span class="arrow {{if @isExpanded 'arrow--expanded'}}">
      <PrismIcon @color="inherit" @name="chevron-right" @size="small" />
    </span>
  </button>
</template> satisfies TOC<GeneralButtonsButtonExpandArrowSignature>;

export default GeneralButtonsButtonExpandArrow;
